import { Breadcrumbs, Link, Typography } from "@mui/material";
import { useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";
import useLocationHistory from "../../Hooks/useLocationHistory";

type ViewBreadcrumbsProps = {
  label: string;
  sx?: any;
};

function ViewBreadcrumbs({ label, sx }: ViewBreadcrumbsProps) {
  const location = useLocation();
  const { items, navigate, updateCurrentLabel } = useLocationHistory();

  // Sync current location with history on mount and location changes
  useEffect(() => {
    const currentPath = location.pathname;
    const lastItem = items[items.length - 1];

    // If current location is not in history, add it
    if (!lastItem || lastItem.path !== currentPath) {
      navigate(currentPath, label);
    } else if (lastItem.path === currentPath && lastItem.label !== label) {
      // If path matches but label is different, update the label
      updateCurrentLabel(label);
    }
  }, [location.pathname, label]);

  const displayItems = useMemo(() => items, [items]);

  return (
    <Breadcrumbs separator="›" aria-label="breadcrumbs" sx={sx}>
      {displayItems.map((item, index) => {
        const isLast = index === displayItems.length - 1;

        if (isLast) {
          return (
            <Typography key={item.path} sx={{ color: "text.primary" }}>
              {item.label}
            </Typography>
          );
        }

        return (
          <Link
            key={item.path}
            href={item.path}
            underline="hover"
            color="inherit"
            onClick={(e) => {
              e.preventDefault();
              navigate(item.path, item.label);
            }}
          >
            {item.label}
          </Link>
        );
      })}
    </Breadcrumbs>
  );
}

export default ViewBreadcrumbs;
